import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function todayISO() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function fmtInt(n) {
  if (n == null || isNaN(n)) return "0";
  return Math.round(n).toLocaleString("en-US");
}

export function fmtOne(n) {
  if (n == null || isNaN(n)) return "0";
  return Number(n).toLocaleString("en-US", { maximumFractionDigits: 1 });
}

// SAR is pegged to USD at ~3.75. Admin dashboards prefer SAR for
// consistency with the Saudi-first pricing model, so this helper
// coerces any USD-denominated legacy value into SAR at display time.
// Values already stored in SAR should be passed through `fmtSAR`
// directly (skip this helper).
const USD_TO_SAR = 3.75;

export function usdToSar(usd) {
  if (usd == null || isNaN(usd)) return 0;
  return Number(usd) * USD_TO_SAR;
}

export function fmtSAR(sarAmount, decimals = 0) {
  if (sarAmount == null || isNaN(sarAmount)) return "0 ريال";
  const rounded = Number(sarAmount).toLocaleString("en-US", {
    minimumFractionDigits: decimals, maximumFractionDigits: decimals,
  });
  return `${rounded} ريال`;
}
